import { Table } from 'reactstrap';
import i18n, { formatNumber } from '@/utils/i18n';
import ContainerTypeDisplay from '../../../../../components/ContainerType/ContainerTypeDisplay';
import { ContainerType } from '../OrderFulfillmentAddContainerTypes';
import CleanOrDirtyText from '../../../../../components/CleanOrDirtyText';
import { isNumber } from '@/utils/number';
import TrackableItemDisplay from '../../../../../components/TrackableItem/TrackableItemDisplay';

type ContainerStationAmountUpdatesProps = {
  oldAmounts: Record<string, number | boolean>;
  newAmounts: Record<string, number | boolean>;
  containerTypes: ContainerType[];
  containerStations: any[];
  isInternal: boolean;
};

const ContainerStationAmountUpdates = ({
  oldAmounts,
  newAmounts,
  containerTypes,
  containerStations,
  isInternal,
}: ContainerStationAmountUpdatesProps) => {
  const containerStationId = oldAmounts?.containerStationId || '-';

  const containerStation = containerStations.find((cs) => {
    return cs.id === containerStationId;
  });

  const containerTypeIdChanged =
    oldAmounts.containerTypeId !== newAmounts.containerTypeId;

  const containerTypeAmountChanged = oldAmounts.amount !== newAmounts.amount;

  const containerTypeSealedChanged = oldAmounts.sealed !== newAmounts.sealed;

  return (
    <Table style={{ width: '100%', tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th>{i18n.t('OrderFulfillment:containerStationId')}</th>
          <th>{i18n.t('Common:containerType')}</th>
          <th>{i18n.t('Common:amount')}</th>
          <th>{i18n.t('Common:status')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {isInternal && containerStationId !== '-' ? (
              <TrackableItemDisplay trackableItem={containerStation} />
            ) : (
              <TrackableItemDisplay
                trackableItem={containerStation}
                showTrackableItemId={false}
                showLink={false}
              />
            )}
          </td>

          <td className="align-middle">
            {!containerTypeIdChanged && (
              <ContainerTypeDisplay
                containerType={containerTypes.find(
                  (ct) => ct.id === oldAmounts.containerTypeId,
                )}
                showContainerId={false}
                showName={false}
              />
            )}

            {containerTypeIdChanged && (
              <div className="d-flex">
                <ContainerTypeDisplay
                  containerType={containerTypes.find(
                    (ct) => ct.id === oldAmounts.containerTypeId,
                  )}
                  showContainerId={false}
                  showName={false}
                />

                <div className="d-flex align-items-center ms-2">{' -> '}</div>

                <ContainerTypeDisplay
                  containerType={containerTypes.find(
                    (ct) => ct.id === newAmounts.containerTypeId,
                  )}
                  showContainerId={false}
                  showName={false}
                />
              </div>
            )}
          </td>

          <td className="align-middle">
            {!containerTypeAmountChanged && (
              <span className="numbers-formatted">
                {isNumber(oldAmounts.amount)
                  ? formatNumber(oldAmounts.amount)
                  : '-'}
              </span>
            )}
            {containerTypeAmountChanged && (
              <>
                <span className="numbers-formatted">
                  {isNumber(oldAmounts.amount)
                    ? formatNumber(oldAmounts.amount)
                    : '-'}
                </span>
                {' -> '}
                <span className="numbers-formatted">
                  {isNumber(newAmounts.amount)
                    ? formatNumber(newAmounts.amount)
                    : '-'}
                </span>
              </>
            )}
          </td>

          <td className="align-middle">
            {!containerTypeSealedChanged && (
              <CleanOrDirtyText isClean={!!oldAmounts.sealed} />
            )}
            {containerTypeSealedChanged && (
              <>
                <CleanOrDirtyText isClean={!!oldAmounts.sealed} />
                {' -> '}
                <CleanOrDirtyText isClean={!!newAmounts.sealed} />
              </>
            )}
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default ContainerStationAmountUpdates;
